module.exports = __webpack_public_path__ + "static/media/mobile_logo.9af9d98c.png";